import { ref } from "vue";

const getLocations = (page) => {
    const locations = ref([])
    const error = ref([])

    const load = async() => {
        try {
            // console.log('page>>>'+page)
            if( page && page !=='undefined' ) {
                var addpage = '?page=' + page
            } else {
                var addpage = ''
            }

            let locationsdata = await fetch( 'https://rickandmortyapi.com/api/location' + addpage )
            if( !locationsdata.ok ) {
                throw Error('API Says No! No Soup For You!')
            }
            locations.value = await locationsdata.json()
        } catch (err) {
            error.value = err.message
            console.log( err.value )
        }
    }
    return { locations, error, load }
}
export default getLocations